import Layout from "@/views/layout/Index";

export const PersonalRouter = [
  {
    path: "/personal",
    name: "personal",
    component: Layout,
    meta: { title: "个人中心", icon: "fa-group" },
    children: [
      {
        path: "data",
        component: () => import("@/views/personnel/BaseInfo"),
        name: "person-data",
        meta: { title: "基本资料", icon: "fa-id-card" }
      },
      {
        path: "recharge/record",
        component: () => import("@/views/personnel/RechargeRecord"),
        name: "recharge-record",
        meta: { title: "充值记录", icon: "fa-gg" }
      }
    ]
  }
];



